import TabellaRelazioniView from "./TabellaRelazioniView";
import {useContext, useEffect, useState} from "react";
import {RuoliContext} from "../../../../../context/RuoliContext";
import {getRelazioniCertificatoApi} from "../../../../../services/CertificatiServices";
import {LoaderContext} from "../../../../../context/LoaderContext";

export default function TabellaRelazioniControl({
                                                    certificato,
                                                }) {

    const [relazioni, setRelazioni] = useState([]);

    const {isRuoloAdmin, isRuoloCommissario} = useContext(RuoliContext);
    const {startChiamata, endChiamata} = useContext(LoaderContext);

    async function getRelazioni(idCertificato) {
        startChiamata();
        const response = await getRelazioniCertificatoApi(idCertificato);
        setRelazioni(response.data.data);
        endChiamata();
    }

    useEffect(() => {
        if (certificato) {
            getRelazioni(certificato.id_certificato);
        }
    }, [certificato]);

    return (
        <TabellaRelazioniView
            relazioni={relazioni}
            isRuoloAdmin={isRuoloAdmin}
            isRuoloCommissario={isRuoloCommissario}
            certificato={certificato}
        />
    );
}